<template>
  <div>
    <Form :description-title="'Registrar consulta'">
      <CreateButton
        @click="registrarConsulta()"
        :icon="PhCloudCheck"
        :label="'Registrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import CreateButton from "@/components/Buttons/Create.vue";
import Form from "../components/Form.vue";
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField,
} from "@/helpers/formFieldsHandler";
import { showToast as toast } from "@/helpers/UseToasts";
import { dataAso } from "../store";
import { storeApp } from "@/store";
import { onMounted } from "vue";
import * as yup from "@/validator";
import { PhCloudCheck } from "@phosphor-icons/vue";
import AsosService from "../service/asos.service";

const appStore = storeApp.state;
const store = dataAso.state;

const schema = yup.object().shape({
  formConsulta: yup.object().shape({
    medico_id: yup.string().required('Informe um médico').label('Médico'),
    paciente_id: yup.string().required('Informe um paciente').label('Paciente'),
    data: yup.date().required('Informe a data da consulta').label('Data'),
  })
})

async function registrarConsulta () {
  appStore.loading = true

  console.log(store.formConsulta);

  cleanAllFormFields()

  const validate = (await validateFormField(schema, store))

  if (validate && validate.length > 0) {
    console.log(validate);
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  await AsosService.registrarConsulta(store.formConsulta)
    .then(res => {
      appStore.loading = false

      if (res?.data?.success) {
        toast(
          'Sucesso',
          res?.data?.message,
          'success'
        )
        dataAso.dispatch('resetForm')
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar documento',
        'error'
      )
    })
}

onMounted(async () => {
  appStore.loading = true;
  dataAso.commit("reset");
  appStore.loading = false;
});
</script>
